module.exports = __webpack_public_path__ + "static/monitor-704226cf85ebb36b1b65500967ceb494.svg";